/**
 * The rider's point on the map for a storefront DELIVERY request (global
 * customer identity, Phase 7): the customer's pin as a Google Maps search
 * link, which opens the Maps app on a phone and the site on a till. Built
 * from numbers only — never from anything the customer typed. Null when the
 * request carries no well-formed pin (takeaway, an older request, an older
 * backend).
 */
export type DeliveryPin = { lat: number; lng: number; source: string };

export function deliveryMapUrl(
  pin: DeliveryPin | null | undefined,
): string | null {
  if (!pin) return null;
  const { lat, lng } = pin;
  if (
    typeof lat !== "number" ||
    typeof lng !== "number" ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng) ||
    Math.abs(lat) > 90 ||
    Math.abs(lng) > 180
  ) {
    return null;
  }
  return `https://www.google.com/maps/search/?api=1&query=${lat.toFixed(6)},${lng.toFixed(6)}`;
}

/** "I can't set a pin" → an area / country centre: the rider should call. */
export function deliveryPinIsApproximate(
  pin: DeliveryPin | null | undefined,
): boolean {
  return pin?.source === "AREA_FALLBACK";
}
